import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";

const LiveCount = ({ sx }) => {
  const [liveCount, setLiveCount] = useState(null);

  useEffect(() => {
    const checkAndInit = () => {
      if (window.ab && window.ab.getLiveCount) {
        window.ab.getLiveCount((err, data) => {
          if (!err && data) {
            setLiveCount(data.count);
          }
        });
      }
    };

    // Check immediately
    checkAndInit();

    return () => {
      if (window.ab && window.ab.stopLiveCount) {
        window.ab.stopLiveCount();
      }
    };
  }, []);

  if (liveCount === null) return null;

  return (
    <Box
      sx={{
        textAlign: "center",
        padding: 2,
        marginTop: "auto",
        width: "100%",
        backgroundColor: (theme) => theme.palette.background.default,
        ...sx,
      }}
    >
      <Typography variant="body2" color="textSecondary">
        Live Users: {liveCount}
      </Typography>
    </Box>
  );
};

export default LiveCount;
